import styled from 'styled-components';
import color from 'tinycolor2';
import {
  SVGIcon,
} from '@pearsontechnology/aero-components';
import {
  PageNav,
  PageNavItem,
  PageNavLink,
} from 'components/PageStyles';

export const NavWrapper = styled(PageNav)`
  padding: 30px 22px 15px 19px;

  ${(props) => props.newUX && `
  a {
    display:block;
  }

  a:focus-visible {
    outline: none;
    border: 3px solid ${props.theme['color.blueLight']};
  }

  a:focus {
    border-radius: 8px;
  }
  `}
`;

export const NavHeader = styled(PageNavItem)`
  display: flex;
  align-items: center;
  justify-content: start;
  margin-bottom: 20px;
  cursor: default;

  &:hover {
    background: none;
  }
`;

export const NavBackIconLink = styled(PageNavLink)`
  display: flex;
  color: ${(props) => props.theme['color.text.light']};
  position: absolute;
  left: 5px;
`;

export const NavSubTitle = styled.div`
  padding: 0px 6px 5px 11px;
  margin: 6px 0 5px 0;
  font-size: 12px;
  font-weight: bold;
  line-height: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${(props) => props.theme['color.text.light']};
  cursor: default;
`;

export const NavLogo = styled(PageNavItem)`
  padding: 0;
  color: ${(props) => props.theme['sidebar.logoNav.color']};
  overflow: visible;
  
  &:hover {
    background: none;
  }
  
  ${(props) => props.newUX && `
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  letter-spacing: 0.02em;
  font-family: 'Chronicle Display';
  line-height: 19px;
  color: ${props.theme.themeId === 'extra-light' ? props.theme['color.blackLighter'] : props.theme['color.text.title']};
  `}
`;

export const Nav = styled(PageNavItem)`
  justify-content: left;
  font-size: 16px;
  line-height: 19px;
  font-weight: normal;
  margin-bottom: 5px;
  ${(props) => props.newUX && `
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  margin-bottom: 0px;
  `}

  color: ${(props) => props.theme['color.text.body']};

  &:hover {
    outline: none;
    background: ${(props) => color(props.theme['color.text.light']).setAlpha(0.05).toString()};
  }

  ${(props) => props.active && `
    color: ${props.theme['color.primary.text']};

    &:hover {
      background: none;
    }
  `}
  
  ${(props) => props.newUX && `
  &:hover {
    cursor: pointer;
    outline: none;
    color: ${props.theme['color.blackLighter']};
    background: ${props.theme.themeId === 'extra-light' ? props.theme['color.greyLighter'] : props.theme['color.greyDarker']};
    svg  {
      color:${props.theme['color.blackLighter']};
    } 
  }

  &:focus-visible {
    outline: none;
    border: 3px solid ${props.theme['color.blueLight']};
  }

  &:focus {
    border-radius: 8px;
  }

  ${props.active && `
    color:${props.theme['color.blackLighter']};
    background: ${props.theme.themeId === 'extra-light' ? props.theme['color.greyLighter'] : props.theme['color.greyDarker']};

    svg  {
      color: ${props.theme['color.blackLighter']};
    } 

    &:hover {
      cursor: default;
      background: none;
    }
  `}
  `}
`;

export const NavIcon = styled(SVGIcon)`
  fill: ${(props) => props.theme.themeId !== 'extra-light' ? "rgba(68, 68, 68, 1)" : "rgba(255, 255, 255, 1)"};
  
  &:hover {
    fill: ${(props) => props.theme.themeId === 'extra-light' ? "rgba(68, 68, 68, 1)" : "rgba(255, 255, 255, 1)"};
  }
`;

export const IconLeft = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  color: ${(props) => props.active ? props.theme['color.primary'] : props.theme['color.text.light']};
  
  ${(props) => props.newUX && `
  color: ${props.theme.themeId !== 'extra-light' ? "rgba(255, 255, 255, 1)" : "rgba(68, 68, 68, 1)"};

  &:hover {
    color: ${props.theme.themeId !== 'extra-light' ? "rgba(68, 68, 68, 1)" : "rgba(255, 255, 255, 1)"};
  }`}
`;

export const WordmarkSvg = styled.svg`
  fill: ${(props) => props.theme['color.text.title']};
  width: 66px;
  height: auto;
`;

export const BetaTag = styled.div`
  box-shadow: 0 0 0 2px ${(props) => color(props.theme['color.text.body']).setAlpha(0.15).toString()};
  font-size: 12px;
  letter-spacing: 0.1em;
  font-weight: 700;
  text-transform: uppercase;
  border-radius: 4px;
  margin-left: 12px;
  padding: 2px 6px;
  color: ${(props) => props.theme['color.text.body']};
  ${(props) => props.newUX && `
    font-size: 8px;
    line-height: 13px;
    font-weight: 800;
    color: ${props.theme.themeId === 'extra-light' ? props.theme['color.blackLighter'] : props.theme['color.text.title']};
    letter-spacing: unset;
  `}
`;
